export default __webpack_public_path__ + "static/media/default_usinage_picture.6c27e580.png";